import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'HOME_DETAILS_GET',
  GET_SUCCESS: 'HOME_DETAILS_GET_SUCCESS',
  GET_FAILURE: 'HOME_DETAILS_GET_FAILURE',
  INVALIDATE_ITEM: 'HOME_DETAILS_INVALIDATE_ITEM',
};

export const get = actions.get(studentId => `${BASE_URL}/students/${studentId}/home/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};
